import Vue from 'vue';
import VeeValidate from 'vee-validate';
import {VTooltip} from 'v-tooltip';
import {ClickOutside} from './directives/ClickOutside';
import swal from 'sweetalert2';
import SocialSharing from 'vue-social-sharing';

import EditContact from './pages/EditContact';
import ContactsListing from './pages/ContactsListing';
import CampaignsListing from './pages/CampaignsListing';
import DocumentsListing from './pages/DocumentsListing';
import CampaignSubscribers from './pages/CampaignSubscribers';
import EditGroup from './pages/EditGroup';
import LinkRedtailAccount from './pages/LinkRedtailAccount';
import Dashboard from './pages/Dashboard';
import ManageGroups from './pages/ManageGroups';
import AddGroup from './pages/AddGroup';
import Timeline from './pages/Timeline';
import VesselActivities from './pages/VesselActivities';
import CampaignGroups from './pages/CampaignGroups';
import ManageCampaigns from './pages/ManageCampaigns';
import DocumentTemplates from './pages/DocumentTemplates';
import CampaignTemplates from './pages/CampaignTemplates';
import AccountSalesforce from './pages/AccountSalesforce';
import Onboarding from './pages/Onboarding';
import AccountSocialNetworkIntegration from './pages/AccountSocialNetworkIntegration';

import OnboardingLinkRedtailAccount from './pages/OnboardingLinkRedtailAccount';
import OnboardingSocialNetworkingIntegration from './pages/OnboardingSocialNetworkingIntegration';
import OnboardingMailerSetup from './pages/OnboardingMailerSetup';

import AccountCrmSettingsPage from './pages/AccountCrmSettingsPage';
import AccountCrmsGlobalSettingsPage from './pages/AccountCrmsGlobalSettingsPage';
import AccountLandingPagesPage from './pages/AccountLandingPagesPage';
import AccountCatchlightPage from './pages/AccountCatchlightPage';
import AccountEmailDomainPage from './pages/AccountEmailDomainPage';
import AccountGalleryPage from './pages/AccountGalleryPage';
import AccountTimezonePage from './pages/AccountTimezonePage';
import AccountTroubleshooting from './pages/AccountTroubleshooting';
import AccountBillingPage from './pages/AccountBillingPage';
import AccountMassLaunchPage from './pages/AccountMassLaunchPage';
import AccountBlocklistTermsPage from './pages/AccountBlocklistTermsPage';
import ComplianceDocPage from './pages/ComplianceDocPage';
import ContactImportReportPage from './pages/ContactImportReportPage';
import ContactImportsListPage from './pages/ContactImportsListPage';
import AccountTwoFactorAuthenticationPage from './pages/AccountTwoFactorAuthenticationPage';
import AccountLoginDetailsPage from './pages/AccountLoginDetailsPage';
import AccountNotificationsPage from './pages/AccountNotificationsPage';
import PasswordResetPage from './pages/PasswordResetPage';
import CheckoutPage from './pages/CheckoutPage';
import PaymentPage from './pages/PaymentPage';
import RegistrationPage from './pages/RegistrationPage';
import RegistrationPageSso from './pages/RegistrationPageSso';
import ImportSelectMethodPage from './pages/ImportSelectMethodPage';
import ImportSelectGroupsPage from './pages/ImportSelectGroupsPage';
import ImportConfirmPage from './pages/ImportConfirmPage';
import ImportProgressPage from './pages/ImportProgressPage';
import ImportCompletePage from './pages/ImportCompletePage';
import IntegrationsCataloguePage from './pages/IntegrationsCataloguePage';
import IntegrationDetailsPage from './pages/IntegrationDetailsPage';
import IntegrationsAuthRedtailPage from './pages/IntegrationsAuthRedtailPage';
import IntegrationsAuthSuccessPage from './pages/IntegrationsAuthSuccessPage';
import IntegrationsAuthFailedPage from './pages/IntegrationsAuthFailedPage';
import NoCrmErrorPage from './pages/NoCrmErrorPage';
import Notifications from './components/Notifications';
import SyncCompletePage from './pages/SyncCompletePage';
import SyncConfirmPage from './pages/SyncConfirmPage';
import SyncManagementPage from './pages/SyncManagementPage';
import SyncProgressPage from './pages/SyncProgressPage';
import SyncSelectGroupsPage from './pages/SyncSelectGroupsPage';
import SyncSelectMethodPage from './pages/SyncSelectMethodPage';

import {initializePusher} from './utility/notifications/initializePusher';

import * as Sentry from "@sentry/vue";
import {addAxiosResponseInterceptor} from './utility/api/addAxiosResponseInterceptor';
import {getEnvironmentVars} from './utility/api/open/getEnvironmentVars';
import {initializeSentry} from './utility/tracking/initializeSentry';
import {initializeSegment} from './utility/tracking/initializeSegment';
import {initializeAuthCheck} from './utility/api/initializeAuthCheck';

window.Pusher = require('pusher-js');

getEnvironmentVars().then(environmentVars => {
  initializeSentry(environmentVars);
  addAxiosResponseInterceptor();

  initializeAuthCheck(environmentVars);
  initializePusher(environmentVars);
  initializeSegment(environmentVars);

  window.SK_USER_TIMEZONE = environmentVars.timezone;
});

// needed for instantiation outside of this JS bundle (e.g. in /views/documents/edit.blade.php)
window.Vue = Vue;

Vue.use(SocialSharing);

window.onload = () => {
  Vue.use(VeeValidate);
  Vue.use(VTooltip);
  Vue.directive('tooltip', VTooltip);

  new Vue({
    el: '#app-v2',
    components: {
      swal,
      AccountCrmsGlobalSettingsPage,
      AccountCrmSettingsPage,
      AccountLandingPagesPage,
      AccountCatchlightPage,
      AccountEmailDomainPage,
      AccountGalleryPage,
      AccountTimezonePage,
      AccountTroubleshooting,
      AccountTwoFactorAuthenticationPage,
      AccountLoginDetailsPage,
      AccountNotificationsPage,
      AccountBillingPage,
      AccountMassLaunchPage,
      AccountBlocklistTermsPage,
      ComplianceDocPage,
      ContactImportsListPage,
      ContactImportReportPage,
      ImportSelectMethodPage,
      ImportSelectGroupsPage,
      ImportConfirmPage,
      ImportProgressPage,
      ImportCompletePage,
      IntegrationsCataloguePage,
      IntegrationDetailsPage,
      IntegrationsAuthRedtailPage,
      IntegrationsAuthSuccessPage,
      IntegrationsAuthFailedPage,
      PasswordResetPage,
      CheckoutPage,
      PaymentPage,
      RegistrationPage,
      RegistrationPageSso,
      NoCrmErrorPage,
      Notifications,
      SyncCompletePage,
      SyncConfirmPage,
      SyncManagementPage,
      SyncProgressPage,
      SyncSelectGroupsPage,
      SyncSelectMethodPage,
    },
    data() {
      return {
        vueAppErrors: [],
      };
    },
    methods: {
      onVueAppErrors(errors) {
        this.vueAppErrors = errors;
      },
    },
  });
};
